// extracted by mini-css-extract-plugin
export default {"div":"wrapper_div__I3Yor"};